/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_IntroInputs */

const en_directory_hubs_signals_geo_intro = /** @type {(inputs: Directory_Hubs_Signals_Geo_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO (Generative Engine Optimization) measures how ready a page is to be quoted by AI answer engines — ChatGPT, Perplexity, Claude, and Google AI Overviews. Classic SEO gets you ranked; GEO gets you quoted. The score audits the page itself: can crawlers reach it, can machines parse it, can engines trust it enough to cite it.`)
};

const zh_directory_hubs_signals_geo_intro = /** @type {(inputs: Directory_Hubs_Signals_Geo_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO（生成式引擎优化）衡量页面被 AI 答案引擎——ChatGPT、Perplexity、Claude、Google AI Overviews——引用的就绪程度。经典 SEO 让你获得排名；GEO 让你被引用。评分审计的是页面本身：爬虫能否到达、机器能否解析、引擎是否信任到愿意引用。`)
};

/**
* | output |
* | --- |
* | "GEO (Generative Engine Optimization) measures how ready a page is to be quoted by AI answer engines — ChatGPT, Perplexity, Claude, and Google AI Overviews. C..." |
*
* @param {Directory_Hubs_Signals_Geo_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_intro = /** @type {((inputs?: Directory_Hubs_Signals_Geo_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_intro(inputs)
	return zh_directory_hubs_signals_geo_intro(inputs)
});
export { directory_hubs_signals_geo_intro as "directory.hubs.signals.geo.intro" }